import { Component, OnInit, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { map, Observable, startWith } from 'rxjs';
import { ChartAccountService } from 'src/app/chart-accounts/shared/chart-account.service';
import { SessionService } from 'src/app/_shared/services/session.service';
import { SharedModule } from 'src/app/_shared/shared.module';
import { ProductService } from '../../services/product.service';

@Component({
  selector: 'app-product-accounting',
  templateUrl: './product-accounting.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class ProductAccountingComponent implements OnInit {
  @Input() product: any;
  @Input() type: any;

  chartAccounts: any;

  loadingData: boolean = false;
  invalidChartAccounts: boolean = true;
  sendingChartAccounts: boolean = false;

  slideChecked: boolean = false;

  incomeAccountControl = new FormControl('');
  expenseAccountControl = new FormControl('');

  filteredIncomeAccounts: Observable<any[]>;
  filteredExpenseAccounts: Observable<any[]>;

  incomeAccount: string = '';
  expenseAccount: string = '';

  filterCriteria = this.chartAccountService.getFilterCriteria();
  private companyId = this.sessionService.getSelectedAccountCompany().id;

  constructor(
    private chartAccountService: ChartAccountService,
    private sessionService: SessionService,
    private productService: ProductService
  ) {}

  ngOnInit(): void {
    this.getChartAccounts();
  }

  slideChange() {
    this.slideChecked = !this.slideChecked;
    this.invalidChartAccounts = this.slideChecked ? false : true;
  }

  incomeSelected(value: any) {
    this.incomeAccount = value;
  }

  expenseSelected(value: any) {
    this.expenseAccount = value;
  }

  applyChartAccounts(product: any) {
    product.accounting_ids = [this.incomeAccount, this.expenseAccount];

    this.sendingChartAccounts = true;

    this.productService.applyAccounting(product, this.type, true).subscribe((response) => {
      this.product = response;

      this.sendingChartAccounts = false;
    });
  }

  cancelChartAccounts() {
    this.sendingChartAccounts = false;
    this.slideChecked = false;
  }

  private filtered(chartAccounts: any) {
    let incomeChartAccounts = chartAccounts.filter(
      (chartAccount) => chartAccount.chart_account_type.name === 'Income'
    );

    this.filteredIncomeAccounts = this.incomeAccountControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value || '', incomeChartAccounts))
    );

    let expenseChartAccounts = chartAccounts.filter(
      (chartAccount) => chartAccount.chart_account_type.name === 'Expenses'
    );

    this.filteredExpenseAccounts = this.expenseAccountControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value || '', expenseChartAccounts))
    );
  }

  private _filter(value: string, chartAccounts: any): string[] {
    const filterValue = value.toLowerCase();

    return chartAccounts.filter((option) => option.name.toLowerCase().includes(filterValue));
  }

  private getChartAccounts() {
    this.filterCriteria.company_id = this.companyId;
    this.filterCriteria.by_chart_account_types = 'Income,Expenses';

    this.loadingData = true;

    this.chartAccountService.getChartAccounts(this.filterCriteria).subscribe((response) => {
      this.chartAccounts = response.data;

      this.chartAccounts.forEach((chartAccount) => {
        if (
          (this.product.accounting_ids && chartAccount.id === this.product.accounting_ids[0]) ||
          (this.product.product_category.income_account_id &&
            chartAccount.id === this.product.product_category.income_account_id)
        ) {
          this.incomeAccountControl.setValue(`${chartAccount.code} ${chartAccount.name}`);
          this.incomeAccount = chartAccount.id;
        }
        if (
          (this.product.accounting_ids && chartAccount.id === this.product.accounting_ids[1]) ||
          chartAccount.id === this.product.product_category.expense_account_id
        ) {
          this.expenseAccountControl.setValue(`${chartAccount.code} ${chartAccount.name}`);
          this.expenseAccount = chartAccount.id;
        }
      });

      this.filtered(this.chartAccounts);

      this.loadingData = false;
    });
  }
}
